
import RspSettingsService from './RspSettingsService';

export { default } from './RspSettingsService';
export const rspSettingsService = new RspSettingsService();